export enum ENV_TYPE {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  UAT = 'uat',
  PROD = 'prod',
}
